<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--8">
      <div class="card shadow">
        <div class="row p-3">
          <div class="col-lg-6 col-6 mb-1" v-if="is_allowed_create">
            <button v-if="is_allowed_delete"
              :disabled="!showActionDelete"
              v-on:click="showConfirmationModal = true"
              class="btn btn-danger"
            >
              <i class="fa fa-trash"></i> Delete
            </button>
            <button
              v-on:click="onEditRow"
              :disabled="!showActionEdit"
              class="btn btn-primary">
              <i class="fa fa-edit"></i> Edit
            </button>
            <button v-on:click="onCreateNewFlashPromo" class="btn btn-primary">
              Create Flash Promo
            </button>
          </div>
          <div class="col-6 pull-right">
            <div class="row">
              <label class="col-4 col-form-label form-control-label text-right">
                brand
              </label>
              <div class="col-8">
                <model-list-select
                  :list="brandCodeOption"
                  v-model="watch_brand_code"
                  option-value="value"
                  option-text="text"
                  placeholder="select merchant item">
                </model-list-select>
              </div>
            </div>
          </div>
        </div>
        <div v-if="message">
          <base-alert :type="message.type" :dismissible="true" @resetMessage="resetMessage">{{
            message.message
          }}</base-alert>
        </div>
        <div v-if="deleteMessages">
          <base-alert
            :type="deleteMessages[0].type"
            :dismissible="true"
            v-for="(row, index) in deleteMessages"
            :key="index"
            >{{ row.message }}</base-alert
          >
        </div>
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="classes"
          @on-select-row="onSelectRow"
          @on-unselect-row="onSelectRow"
          @refresh-data="onRefreshData"
        >
         <template slot="discount_type_column" slot-scope="props">
            <label v-if="props.cell_value == '1'">
            Discount price amount
            </label>
            <label v-if="props.cell_value == '2'">
            Discount percentage
            </label>
            <label v-if="props.cell_value == '3'">
            Special Offer
            </label>
          </template>
          <template slot="start_date_column" slot-scope="props">
           {{props.cell_value}}        
          </template>
           <template slot="end_date_column" slot-scope="props">
           {{props.cell_value}}         
          </template>
        </vue-bootstrap4-table>
      </div>
    </div>
    <modal :show.sync="showConfirmationModal" modalClasses="modal-sm">
      <h3>Are you sure to delete these items?</h3>
      <ul>
        <li v-for="(row, index) in selectedItems" :key="index">
          {{ row.promotion_name }}
        </li>
      </ul>
      <template slot="footer">
        <div class="row">
          <div class="col-lg-6">
            <base-button
              type="link"
              class="ml-auto btn-block"
              @click="showConfirmationModal = false"
              >No
            </base-button>
          </div>
          <div class="col-lg-6">
            <base-button
              type="primary"
              class="ml-auto btn-block"
              @click="onDeleteRow"
              >Yes
            </base-button>
          </div>
        </div>
      </template>
    </modal>
    <modal :show.sync="showModalCreate" modal-classes="modal-lg">
      <h3 slot="header" class="modal-title" id="modal-title-default">
        {{ this.titlePopup }} Product Catalog
      </h3>
      <form @submit.prevent>
        <div class="row">
          <div class="col-lg-12">
            <base-input
              alternative=""
              label="Promotion Name"
              input-classes="form-control"
              v-model="flashPromoModel.promotion_name"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group has-label">
              <label class="form-control-label">
                Brand Code
              </label>
              <model-list-select
                :list="brandCodeOption"
                v-model="watch_brand_code"
                option-value="value"
                option-text="text"
                placeholder="select merchant item"
                :isDisabled="isBrandCodeDisabled"
              >
              </model-list-select>
            </div>
          </div>
        </div>
        <div class="row">
         <div class="col-lg-12">
                <label class="form-control-label">Discount Type</label>
                <model-list-select
                  :list="discountType"
                  v-model="flashPromoModel.discount_type"
                  option-value="value"
                  option-text="text"
                  placeholder="Discount Type"
                  class="mt-2"
                >
                </model-list-select>
              </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <base-input
              label="Promotion Amount"
              input-classes="form-control"
              v-model="flashPromoModel.promotion_amount"
              type="number"
            />
          </div>
        </div>
         <div class="row">
          <div class="col-lg-12">
            <div class="form-group has-label">
              <label class="form-control-label">
                Start End Date
              </label>
              <date-picker
                v-model="startEndDate"
                range
                editable
                clearable
                value-type="YYYY-MM-DD"
                id="StartEndDate"
                :default-value="startEndDate"
                style="width: 100%"
              ></date-picker>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group has-label">
              <label class="form-control-label">
                Is Active
              </label>
              <base-checkbox
                alternative=""
                input-classes="form-control"
                v-model="flashPromoModel.is_active"
                value=true
              />
            </div>
          </div>
        </div>
      </form>
      <template slot="footer">
        <base-button
          type="link"
          class="ml-auto"
          @click="showModalCreate = false"
          >Close/ Cancel
        </base-button>
        <button
          v-on:click="createUpdateFlashPromoConfigs"
          class="btn btn-primary"
          v-bind:disabled="
            !(
            this.flashPromoModel.brandCode &&
            this.flashPromoModel.promotion_name &&
            this.flashPromoModel.discount_type &&
            this.flashPromoModel.promotion_amount
            ) 
          "
        >
          Submit
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import api_loyalty from "../api/api";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
// import { API } from "aws-amplify";
// import * as queries from "../graphql/queries";
import BaseCheckbox from '../components/BaseCheckbox.vue';
import "vue2-datepicker/index.css";

export default {
  name: "flashProductList",
  data() {
    return {
      is_allowed_create: false,
      watch_brand_code: "PHFortune",
      deleteMessages: [],
      showConfirmationModal: false,
      selectedItems: [],
      showActionEdit: false,
      showActionDelete: false,
      brandCodeOption: [],
      DateRangeModel: null,
      startEndDate: [],
      ActivePromo: {},
      TimeZoneConfigValue: "",
      discountType: [
        { text: "Discount price amount", value: "1" },
        { text: "Discount percentage", value: "2" },
        { text: "Special Offer", value: "3" },
      ],
      titlePopup: "Create",
      message: null,
      isBrandCodeDisabled: false,
      flashPromoModel: {
        brandCode: "PHFortune",
        promotion_name: "",
        promotion_amount: "",
        discount_type: "",
        is_active: true,
        start_date: new Date().toISOString(),
        end_date:new Date().toISOString(),
        create_date: new Date().toISOString(),
        modify_date: new Date().toISOString(),
        product_items:[],
      },
      showModalCreate: false,
      showModalDetail: false,
      rows: [],
      allFlashPromoConfigs: null,
      columns: [
        {
          label: "ID",
          name: "id",
          slot_name: "action_button",
        },
        {
          label: "Brand",
          name: "brandCode",
          sort: true,
        },
        {
          label: "Promotion Name",
          name: "promotion_name",
          sort: true,
        },
        {
          label: "Start Date",
          name: "start_date",
          slot_name: "start_date_column",
          sort: true,
        },
         {
          label: "End Date",
          name: "end_date",
          slot_name: "end_date_column",
          sort: true,
        },
        {
          label: "Discount Type",
          name: "discount_type",
          slot_name: "discount_type_column",
          sort: true,
        },
        {
          label: "Promotion Amount",
          name: "promotion_amount",
          sort: true,
        },
        {
          label: "Is Promo Active",
          name: "is_active",
          sort: true,
        },
      ],
      config: {
        pagination: true,
        pagination_info: true,
        num_of_visibile_pagination_buttons: 7,
        per_page: 10,
        checkbox_rows: true,
        highlight_row_hover: true,
        rows_selectable: true,
        multi_column_sort: false,
        card_mode: false,
        selected_rows_info: true,
        per_page_options: [5, 10, 20, 30],
      },
      classes: {
        table: "table-striped table-bordered",
        row: {
          "my-row my-row2": true,
          "function-class": function(row) {
            return row.id == 1;
          },
        },
      },
    };
  },
  created() {
    this.is_allowed_delete = this.$store.getters.isLoginUserAdmin;
    this.mappingRole();
    this.onRefreshData();
    this.isBrandCodeDisabled = false;
    this.LoadTimezoneConfig();
  },
  methods: {
    mappingRole() {
      let isChe = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phche') &&
        object.menu.toLowerCase().includes('flashpromoconfig')
      );
      let isFortune = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phft') ||
        object.role.toLowerCase().includes('fortune') &&
        object.menu.toLowerCase().includes('flashpromoconfig')
      );
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      this.brandCodeOption = [];
      if (isAdministrator || isChe)
      {
        this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHChe";
        this.is_allowed_create = true;
        this.is_allowed_delete = true;
        this.watch_brand_code = "PHChe";
      }

      if (isAdministrator || isFortune)
      {
        this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHFortune";
        this.is_allowed_create = true;
        this.is_allowed_delete = true;
        this.watch_brand_code = "PHFortune";
      }
    },
    ValidateForm() {
      if (
        this.flashPromoModel.brandCode &&
        this.flashPromoModel.promotion_name &&
        this.flashPromoModel.start_date &&
        this.flashPromoModel.end_date &&
        this.flashPromoModel.discount_type &&
        this.flashPromoModel.promotion_amount
      ) {
        this.flashPromoModel.stock =
          this.flashPromoModel.stock == null ? 0 : this.flashPromoModel.stock;
        this.flashPromoModel.win_probability =
          this.flashPromoModel.win_probability == null? 0: this.flashPromoModel.win_probability;
        this.flashPromoModel.user_win_limit =
          this.flashPromoModel.user_win_limit == null? 0: this.flashPromoModel.user_win_limit;
        return true;
      }
      return false;
    },
    resetMessage(){
      this.message = null;
    },
    LoadTimezoneConfig() {
      api_loyalty.GetTimeZoneConfig(this.watch_brand_code).then((data) => {
        if (data.isSuccess) {
          this.TimeZoneConfigValue = data.data.value;
        }
      });
    },
    onResetForm() {
      let momNow = this.$moment(new Date().toUTCString());
      let StartDate = momNow.format("YYYY-MM-DD");
      let momStart = this.$moment(new Date(StartDate)).format("YYYY-MM-DD");

      this.startEndDate = [momStart, momStart];
      this.flashPromoModel = {
        brandCode: this.watch_brand_code,
        promotion_name: "",
        promotion_amount: "",
        discount_type: "",
        is_active: true,
        start_date: new Date().toISOString(),
        end_date:new Date().toISOString(),
        create_date: new Date().toISOString(),
        modify_date: new Date().toISOString(),
        product_items:[],
      };
      this.isBrandCodeDisabled=false;
    },
    onCreateNewFlashPromo() {
      this.showModalCreate = true;
      this.titlePopup = "Create";
      this.onResetForm();
      this.isBrandCodeDisabled = false;
    },
    toggleActive() {},
    async onRefreshData() {
     api_loyalty.GetAllFlashPromoConfig(this.watch_brand_code).then((data) => {
      try {
        if(data.isSuccess)
        {
          this.rows = data.data;
          this.allFlashPromoConfigs = data.data;
        }
      } catch (e) {
        console.log(e);
      }
    });
    },
    onSelectRow(payload) {
      this.showActionEdit = true;
      this.showActionDelete = true;
      this.selectedItems = payload.selected_items;
      if (payload.selected_items.length == 0) {
        this.showActionEdit = false;
        this.showActionDelete = false;
      }
      if (payload.selected_items.length > 1) {
        this.showActionEdit = false;
      }
    },
    onEditRow() {
      this.flashPromoModel = this.allFlashPromoConfigs.filter(
        (x) => x.id === this.selectedItems[0].id
      )[0];
      var start_date = new Date(this.flashPromoModel.start_date);
      //ada perbedaan antara get tgl dr dynamo dan mysql.
      var hours = start_date.getHours() + parseInt(this.TimeZoneConfigValue) * 2;
      start_date.setHours(
        hours
      );
      var end_date = new Date(this.flashPromoModel.end_date);
      end_date.setHours(
        hours
      );
      this.startEndDate = [start_date.toISOString(), end_date.toISOString()];
      this.showModalCreate = true;
      this.titlePopup = "Update";
      this.isBrandCodeDisabled = true;
    },
    onDeleteRow() {
      this.selectedItems.forEach((element) => {
        let deleteRequest = {
          id: element.id,
        };
        api_loyalty
          .DeleteFlashPromoConfig(this.watch_brand_code, deleteRequest)
          .then((data) => {
            if(data.isSuccess){
              this.onRefreshData();
              let msg = {
                message:
                  "Success delete flash promo config '" + element.promotion_name + "'.",
                type: "success",
              };
              this.deleteMessages.push(msg);
            }
          })
          .catch((e) => {
            console.log(e);
            var msg = {
              message:
                "Failed to delete flash promo config '" +
                element.promotion_name +
                "'.",
              type: "danger",
            };

            if (e.response && e.response.status === 401)
            {
              msg = {
                message: "You don't have a permission",
                type: 'danger'
              }
            }
            this.deleteMessages.push(msg);
          });
      });
      this.showConfirmationModal = false;
    },
    async createUpdateFlashPromoConfigs() {
      if(this.startEndDate.length > 1){ 
        this.flashPromoModel.start_date = new Date(this.startEndDate[0]).toISOString();
        this.flashPromoModel.end_date = new Date(this.startEndDate[1]).toISOString();
      }
      api_loyalty.checkExistFlashPromoConfig(this.watch_brand_code,this.flashPromoModel.start_date,this.flashPromoModel.end_date,this.flashPromoModel.id).then((data) => 
      {
        try 
        {
          if(data.isSuccess)
          {
            this.ActivePromo = data.data;
          }

          if(this.ActivePromo?.id ==null)
          {
            if (this.flashPromoModel.id) 
            {
              delete this.flashPromoModel.start_date_str;
              delete this.flashPromoModel.end_date_str;
              this.flashPromoModel.modify_date = new Date().toISOString();
              this.flashPromoModel.brandCode = this.watch_brand_code;

              api_loyalty.UpdateFlashPromoConfig(this.watch_brand_code,this.flashPromoModel).then((data) => {
              try {
                  if(data.isSuccess)
                  {
                      this.onRefreshData();
                      this.message = {
                      message: "Flash promo config updated successfully.",
                      type: "success",
                    };
                  }
                  else
                  {
                      this.message = {
                      message: "Failed to update flash promo config.",
                      type: "danger",
                    };
                  }
              } catch (e) {
                console.log(e);
                this.message = {
                  message: "Failed to update flash promo config.",
                  type: "danger",
                }
              }
              });
            } else {
              this.flashPromoModel.brandCode = this.watch_brand_code;
              this.flashPromoModel.create_date = new Date().toISOString();
              this.flashPromoModel.modify_date = new Date().toISOString();

              api_loyalty.AddFlashPromoConfig(this.watch_brand_code,this.flashPromoModel).then((data) => 
              {
                try 
                {
                    if(data.isSuccess)
                    {
                        this.onRefreshData();
                        this.message = {
                        message: "Flash promo config created successfully.",
                        type: "success",
                      };
                    }
                    else
                    {
                        this.message = {
                        message: "Failed to created flash promo config.",
                        type: "danger",
                      };
                    }
                } catch (e) {
                  console.log(e);
                  this.message = {
                    message: "Failed to create flash promo config",
                    type: 'danger'
                  }
                }
              });
            }
          }
          else
          {
            this.message = {
                        message: "Choose a different date range, because the date is already in use by " + this.ActivePromo.promotion_name,
                        type: "danger",
                      };
          }
          this.onResetForm();
          this.showModalCreate = false;
        } catch (e) {
          console.log(e);
        }
      });
    },
  },
  components: {
    VueBootstrap4Table,
    ModelListSelect,
    BaseCheckbox,
  },
  watch: {
    watch_brand_code: function(val) {
      this.flashPromoModel.brandCode = this.watch_brand_code;
      switch (val) {
        case "PHChe":
          this.allMerchants = this.CheMerchants;
          break;
        default:
          this.allMerchants = this.FortuneMerchants;
          break;
      }
      this.onRefreshData();
    },
  },
};
</script>
<style></style>
